module.exports = __webpack_public_path__ + "static/tangdouren-115a76ba15767630c9ac203fbd1c5aea.jpg";